export default __webpack_public_path__ + "static/media/forgot-password-icon.59153ff7.svg";